import {makeObservable, observable, runInAction} from 'mobx'

import type {CertificatesPageContent} from "@/src/core/domain/entities/catalog";

export class CertificatesViewModel {
  @observable
  data!: CertificatesPageContent

  @observable
  selectedCertificate: Nullable<ArrayItem<CertificatesPageContent['certificates']>> = null

  constructor(data: CertificatesPageContent) {
    makeObservable(this)

    runInAction(() => {
      this.data = data

      if (!this.data.certificates) {
        this.data.certificates = []
      }

      if ((data.certificates ?? []).length > 0) {
        this.selectedCertificate = data.certificates[0]!
      }
    })
  }

  @observable
  selectCertificate(certificate: Nullable<ArrayItem<CertificatesPageContent['certificates']>>) {
    this.selectedCertificate = certificate
  }
}
